import * as rcc from "../constants/rcc";
import * as windowService from "../services/windowService";

import Channel from "../models/entities/Channel";
import Colorant from "../models/entities/Colorant";

export const processSensorList = (list) => {
    if (list === null || !Array.isArray(list)) {
        return {};
    }
    let item;
    let sensors = {};
    for (item of list) {
        if (rcc.RCC_LIST_OF_AVAILABLE_SENSORS.includes(item.name)) {
            sensors[item.name] = item.state;
        }
    }
    return sensors;
};

export const processChannelList = (list) => {
    if (list === null || !Array.isArray(list)) {
        return [];
    }

    let channels = [];

    try {
        let item;
        for (item of list) {
            if (item !== null && item.index !== null) {
                channels.push(
                    new Channel(
                        item.index,
                        item.cntSpecificWeight === null ? 0 : item.cntSpecificWeight,
                        item.cntCode !== null
                            ? new Colorant(0, item.cntCode, item.cntCode, item.cntRGB, 0, "", item.cntSpecificWeight)
                            : null,
                        item.enabled !== true ? false : true
                    )
                );
            }
        }
    } catch (e) {
        windowService.logError("6D9C3E09619BE73", e.message);
        return [];
    }

    return channels;
};

const getValidationResult = (validationResults, canister) => {
    let newItem = validationResults.find((result) => result.canister !== null && result.canister.index === canister.id);
    if (newItem !== undefined && newItem.canister !== null) {
        switch (newItem.validation) {
            case rcc.RCC_VALIDATION_MANUAL_COLORANT_ADDITION:
            case rcc.RCC_VALIDATION_MANUAL_COLORANT_ADDITION_CUSTOM_CAN:
                if (newItem.canister.currentLevel - newItem.volume < newItem.canister.minimumLevel) {
                    newItem.validation = rcc.RCC_VALIDATION_CRITICAL_LEVEL_AND_MANUAL;
                    break;
                }
                if (newItem.canister.currentLevel - newItem.volume < newItem.canister.warningLevel) {
                    newItem.validation = rcc.RCC_VALIDATION_WARNING_LEVEL_AND_MANUAL;
                    break;
                }
                break;
            case rcc.RCC_VALIDATION_SPLIT_FORMULA:
                if (newItem.canister.currentLevel - newItem.volume < newItem.canister.minimumLevel) {
                    newItem.validation = rcc.RCC_VALIDATION_CRITICAL_LEVEL_AND_SPLIT;
                    break;
                }
                if (newItem.canister.currentLevel - newItem.volume < newItem.canister.warningLevel) {
                    newItem.validation = rcc.RCC_VALIDATION_WARNING_LEVEL_AND_SPLIT;
                    break;
                }
                break;
            default:
                break;
        }
    }
    return newItem;
};

const areLevelsValid = (rawCanister) => {
    if (isNaN(rawCanister.currentLevel)) {
        return false;
    }

    if (isNaN(rawCanister.currentLevelMl)) {
        return false;
    }

    if (isNaN(rawCanister.minimumLevel)) {
        return false;
    }

    if (isNaN(rawCanister.minimumLevelMl)) {
        return false;
    }

    if (isNaN(rawCanister.warningLevel)) {
        return false;
    }

    if (isNaN(rawCanister.warningLevelMl)) {
        return false;
    }

    return true;
};

export const updateCanisterList = (list, update) => {
    if (update === null || !Array.isArray(update)) {
        return list;
    }

    let canister, newItem;
    let newCanisters = [];
    for (canister of list) {
        newItem = getValidationResult(update[1], canister);

        if (newItem !== undefined && areLevelsValid(newItem.canister)) {
            newCanisters.push(
                canister.updateLevels(
                    newItem.canister.currentLevel,
                    newItem.canister.currentLevelMl,
                    newItem.canister.minimumLevel,
                    newItem.canister.minimumLevelMl,
                    newItem.canister.warningLevel,
                    newItem.canister.warningLevelMl
                )
            );
        } else {
            newCanisters.push(canister);
        }
    }

    return newCanisters;
};

const mapDriverByType = (type, configuration) => {
    try {
        switch (type) {
            case rcc.DRIVER_TYPE_ALFA_REST_API:
                return {
                    type: rcc.DRIVER_TYPE_ALFA_REST_API,
                    name: "Alfa Rest API",
                    host: configuration[rcc.DRIVER_TYPE_ALFA_REST_API].host,
                    port: configuration[rcc.DRIVER_TYPE_ALFA_REST_API].port
                };
            case rcc.DRIVER_TYPE_COROB_DS_PROXY:
                return {
                    type: rcc.DRIVER_TYPE_COROB_DS_PROXY,
                    name: "Corob using DspProxy"
                };
            case rcc.DRIVER_TYPE_COROB_EVO_DRIVER:
                return {
                    type: rcc.DRIVER_TYPE_COROB_EVO_DRIVER,
                    name: "Corob using EvoDriver"
                };
            case rcc.DRIVER_TYPE_COROB_NEXT_DRIVER:
                return {
                    type: rcc.DRIVER_TYPE_COROB_NEXT_DRIVER,
                    name: "Corob using NextDriver"
                };
            case rcc.DRIVER_TYPE_DROMONT_DDRV:
                return {
                    type: rcc.DRIVER_TYPE_DROMONT_DDRV,
                    name: "Dromont D_DRV (v1/v2)",
                    path: configuration[rcc.DRIVER_TYPE_DROMONT_DDRV].driver_path,
                    configurationPath: configuration[rcc.DRIVER_TYPE_DROMONT_DDRV].configuration_path,
                    databasePath: configuration[rcc.DRIVER_TYPE_DROMONT_DDRV].database_path,
                    serviceSwPath: configuration[rcc.DRIVER_TYPE_DROMONT_DDRV].service_sw_path
                };
            case rcc.DRIVER_TYPE_DROMONT_MISURA:
                return {
                    type: rcc.DRIVER_TYPE_DROMONT_MISURA,
                    name: "Dromont Misura (v3)",
                    path: configuration[rcc.DRIVER_TYPE_DROMONT_MISURA].driver_path,
                    extensionPath: configuration[rcc.DRIVER_TYPE_DROMONT_MISURA].extension_path,
                    formulaPath: configuration[rcc.DRIVER_TYPE_DROMONT_MISURA].formula_path
                };
            case rcc.DRIVER_TYPE_DROMONT_V2:
                return {
                    type: rcc.DRIVER_TYPE_DROMONT_V2,
                    name: "Dromont direct (v1/v2)",
                    path: configuration[rcc.DRIVER_TYPE_DROMONT_V2].folder
                };
            case rcc.DRIVER_TYPE_FLUID_IDD:
                return {
                    type: rcc.DRIVER_TYPE_FLUID_IDD,
                    name: "Fast & Fluid using IDD",
                    path: configuration[rcc.DRIVER_TYPE_FLUID_IDD].path
                };
            case rcc.DRIVER_TYPE_FLUID_UIDD:
                return {
                    type: rcc.DRIVER_TYPE_FLUID_UIDD,
                    name: "Fast & Fluid using UIDD",
                    host: configuration[rcc.DRIVER_TYPE_FLUID_UIDD].host,
                    port: configuration[rcc.DRIVER_TYPE_FLUID_UIDD].port,
                    user: configuration[rcc.DRIVER_TYPE_FLUID_UIDD].user,
                    password: configuration[rcc.DRIVER_TYPE_FLUID_UIDD].password
                };
            case rcc.DRIVER_TYPE_HERO:
                return {
                    type: rcc.DRIVER_TYPE_HERO,
                    name: "Hero using PCPDriver"
                };
            case rcc.DRIVER_TYPE_ITALTINTO:
                return {
                    type: rcc.DRIVER_TYPE_ITALTINTO,
                    name: "Italtinto",
                    path: configuration[rcc.DRIVER_TYPE_ITALTINTO].path
                };
            case rcc.DRIVER_TYPE_LLD:
                return {
                    type: rcc.DRIVER_TYPE_LLD,
                    name: "Corob FLEX 500 series using LLD",
                    path: configuration[rcc.DRIVER_TYPE_LLD].hld_path,
                    dispenser: configuration[rcc.DRIVER_TYPE_LLD].dispenser
                };
            case rcc.DRIVER_TYPE_MANUAL:
                return {
                    type: rcc.DRIVER_TYPE_MANUAL,
                    name: "Manual Advanced",
                    path: configuration[rcc.DRIVER_TYPE_MANUAL].path
                };
            case rcc.DRIVER_TYPE_MANUAL_SIMPLE:
                return {
                    type: rcc.DRIVER_TYPE_MANUAL_SIMPLE,
                    name: "Manual Simple",
                    path: configuration[rcc.DRIVER_TYPE_MANUAL_SIMPLE].path
                };
            case rcc.DRIVER_TYPE_NONE:
                return {
                    type: rcc.DRIVER_TYPE_NONE,
                    name: "-"
                };
            case rcc.DRIVER_TYPE_SANTINT:
                return {
                    type: rcc.DRIVER_TYPE_SANTINT,
                    name: "Santint using ColorLink3"
                };
            case rcc.DRIVER_TYPE_SANTINT_DRIVER:
                return {
                    type: rcc.DRIVER_TYPE_SANTINT_DRIVER,
                    name: "Santint using SantintDriver"
                };
            case rcc.DRIVER_TYPE_SANTINT_JAVA:
                return {
                    type: rcc.DRIVER_TYPE_SANTINT_JAVA,
                    name: "Santint Java"
                };
            case rcc.DRIVER_TYPE_SIMULATION:
                return {
                    type: rcc.DRIVER_TYPE_SIMULATION,
                    name: "Simulation",
                    path: configuration[rcc.DRIVER_TYPE_SIMULATION].path
                };
            case rcc.DRIVER_TYPE_UDCP:
                return {
                    type: rcc.DRIVER_TYPE_UDCP,
                    name: "UDCP"
                };
            default:
                return {
                    type: type,
                    name: type
                };
        }
    } catch (e) {
        return null;
    }
};

export const parseDefaultDriverType = (configuration) => {
    if (
        configuration === undefined ||
        configuration === null ||
        configuration[rcc.CONFIGURATION_GENERAL] === undefined
    ) {
        return null;
    }

    return mapDriverByType(configuration[rcc.CONFIGURATION_GENERAL].type, configuration);
};

export const parseDriverTypes = (configuration, driverTypes) => {
    try {
        let configurationList = {};
        let driver = null;

        let type;
        for (type in configuration) {
            if (driverTypes.includes(type)) {
                driver = mapDriverByType(type, configuration);

                if (driver !== null) {
                    configurationList[type] = driver;
                }
            }
        }

        return configurationList;
    } catch (e) {
        return {};
    }
};

const mapSpectroByType = (type, spectro) => {
    try {
        switch (type) {
            case rcc.SPECTRO_TYPE_COLORIXCC3:
                return {
                    type: rcc.SPECTRO_TYPE_COLORIXCC3,
                    name: "Colorix CC3"
                };
            case rcc.SPECTRO_TYPE_COLORIXNANO:
                return {
                    type: rcc.SPECTRO_TYPE_COLORIXNANO,
                    name: "Colorix Nano",
                    useProfiledValues: spectro[rcc.SPECTRO_TYPE_COLORIXNANO].use_profiled_values
                };
            case rcc.SPECTRO_TYPE_DATACOLOR:
                return {
                    type: rcc.SPECTRO_TYPE_DATACOLOR,
                    name: "Datacolor",
                    useDiagnosticTile: spectro[rcc.SPECTRO_TYPE_DATACOLOR].use_diagnostic_tile,
                    silent: spectro[rcc.SPECTRO_TYPE_DATACOLOR].silent
                };
            case rcc.SPECTRO_TYPE_DATACOLORREADER:
                return {
                    type: rcc.SPECTRO_TYPE_DATACOLORREADER,
                    name: "Datacolor ColorReader",
                    measureModes: spectro[rcc.SPECTRO_TYPE_DATACOLORREADER].enabled_measure_modes
                };
            case rcc.SPECTRO_TYPE_DATACOLORSELECT:
                return {
                    type: rcc.SPECTRO_TYPE_DATACOLORSELECT,
                    name: "Datacolor Select"
                };
            case rcc.SPECTRO_TYPE_EYEONE:
                return {
                    type: rcc.SPECTRO_TYPE_EYEONE,
                    name: "X-Rite Eye One"
                };
            case rcc.SPECTRO_TYPE_MINOLTA:
                return {
                    type: rcc.SPECTRO_TYPE_MINOLTA,
                    name: "Minolta CM-2XXXd",
                    comPort: spectro[rcc.SPECTRO_TYPE_MINOLTA].com_port
                };
            case rcc.SPECTRO_TYPE_NIX:
                return {
                    type: rcc.SPECTRO_TYPE_NIX,
                    name: "Nix Pro",
                    comPort: spectro[rcc.SPECTRO_TYPE_NIX].com_port
                };
            case rcc.SPECTRO_TYPE_NIX_SPECTRO:
                return {
                    type: rcc.SPECTRO_TYPE_NIX_SPECTRO,
                    name: "Nix Spectro",
                    comPort: spectro[rcc.SPECTRO_TYPE_NIX_SPECTRO].com_port
                };
            case rcc.SPECTRO_TYPE_NIX_PRO:
                return {
                    type: rcc.SPECTRO_TYPE_NIX_PRO,
                    name: "Nix Pro",
                    comPort: spectro[rcc.SPECTRO_TYPE_NIX_PRO].com_port
                };
            case rcc.SPECTRO_TYPE_NONE:
                return {
                    type: rcc.SPECTRO_TYPE_NONE,
                    name: "-"
                };
            case rcc.SPECTRO_TYPE_SIMULATION:
                return {
                    type: rcc.SPECTRO_TYPE_SIMULATION,
                    name: "Simulation",
                    path: spectro[rcc.SPECTRO_TYPE_SIMULATION].path
                };
            case rcc.SPECTRO_TYPE_XRITE:
                return {
                    type: rcc.SPECTRO_TYPE_XRITE,
                    name: "X-Rite",
                    model: spectro[rcc.SPECTRO_TYPE_XRITE].model,
                    comPort: spectro[rcc.SPECTRO_TYPE_XRITE].com_port
                };
            default:
                return null;
        }
    } catch (e) {
        return null;
    }
};

export const parseDefaultSpectroType = (configuration) => {
    if (
        configuration === undefined ||
        configuration === null ||
        configuration[rcc.CONFIGURATION_GENERAL] === undefined
    ) {
        return null;
    }

    return mapSpectroByType(configuration[rcc.CONFIGURATION_GENERAL].type, configuration);
};

export const parseSpectroTypes = (configuration, spectroTypes) => {
    try {
        let configurationList = {};
        let spectro = null;

        let type;
        for (type in configuration) {
            if (spectroTypes.includes(type)) {
                spectro = mapSpectroByType(type, configuration);

                if (spectro !== null) {
                    configurationList[type] = spectro;
                }
            }
        }

        return configurationList;
    } catch (e) {
        return {};
    }
};

export const processList = (list) => {
    if (list === null || !Array.isArray(list)) {
        return [];
    }

    let item;
    let driverTypes = [];
    for (item of list) {
        driverTypes.push(item);
    }

    return driverTypes;
};
